import styled from 'styled-components';

const Main = styled.main`
	padding: ${(props) => props.theme.spacing(12)};
`;

export default Main;
